import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { initLenis } from "@/lib/scroll";
import { setupMeta } from "@/lib/meta";
import LandingPage from "@/pages/LandingPage";
import OrderSuccess from "@/pages/OrderSuccess";

export default function App() {
    useEffect(() => {
        initLenis();
        setupMeta();
    }, []);

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/order-success" element={<OrderSuccess />} />
            </Routes>
        </BrowserRouter>
    );
}
